import React from 'react';

const IMG_ALT_FALLBACK = 'img';

export type ImageProps = {
  previewWidth?: number | string;
  url?: string;
  altText?: string;
  textAlignment?: string;
};

const Image = ({ url, previewWidth, altText, textAlignment }: ImageProps) => (
  <div className="w-full flex" style={{ justifyContent: textAlignment }}>
    <img src={url} width={Number(previewWidth)} alt={altText || IMG_ALT_FALLBACK} />
  </div>
);

export default Image;
